module.exports = __webpack_public_path__ + "img/BOOK1.8d90c005.png";